export enum Category {
  Analysis = 'Analysis',
  Education = 'Education',
  Warning = 'Warning',
  Review = 'Review',
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/Category.ts